import React from 'react';
import size from 'lodash/size';
import styled from 'styled-components';

import BusinessHours from 'src/models/BusinessHours/BusinessHours';
import BusinessHoursReference from 'src/models/BusinessHours/BusinessHoursReference';
import analytics from '@ad-scripts/lib/analytics';
import useBusinessHoursReferences from 'src/presentation/components/pages/businessHours/hooks/useBusinessHoursReferences';
import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';

export type PlacesUsedColumnProps = {
  item: BusinessHours;
  openModal: (item: BusinessHours, references: BusinessHoursReference[]) => void;
};

const PlacesUsedColumn = ({ item, openModal }: PlacesUsedColumnProps): JSX.Element => {
  const { id } = item;
  const { references } = useBusinessHoursReferences({ item });
  const count = size(references);

  const handleButtonClick = () => {
    analytics.track(`Admin - Business Hours - Open places used`, { id });
    openModal(item, references);
  };

  return (
    <StyledButton
      data-aid={`referencesLink-${id}`}
      type={ButtonTypes.TEXT}
      disabled={!count}
      onClick={handleButtonClick}
      title={count.toString()}
    >
      {count.toString()}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  color: black;
  text-decoration: underline;

  &:disabled {
    color: black;
    text-decoration: none;
  }
`;

export default PlacesUsedColumn;
